import { formCheck } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Radio = styled.div.withConfig({
  displayName: "Radio",
  componentId: "sc-tr5kfi-0"
})(["", ";"], formCheck());